import React from "react";

export default function GentleFadeIn({ children, show, style, ...other }) {
  return (
    <div
      style={{
        ...style,
        opacity: show ? 1 : 0,
        transition: "opacity 0.1s ease-in-out"
      }}
      {...other}
    >
      {children}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/Animations/FadeIn.js